import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { DxButtonModule, DxDataGridModule } from 'devextreme-angular';
import { exportDataGrid } from 'devextreme/excel_exporter';
import dxDataGrid from 'devextreme/ui/data_grid';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';

@Component({
    selector: 'form-export',
    imports: [CommonModule, DxButtonModule, DxDataGridModule],
    template: `
    @if (datagrid) {
    <dx-button text="Export" type="default" stylingMode="contained" (onClick)="export(datagrid.instance)"></dx-button>
    }
    <dx-data-grid #datagrid [dataSource]="dataSource()" [columnMinWidth]="100" style="visibility: hidden; width: 0px; height: 0px;">
    </dx-data-grid>
  `,
    styles: []
})
export class FormExportComponent {
  dataSource = input.required<any[]>();
  worksheetName = input<string>('Data');
  fileName = input<string>('export');

  async export(datagrid: dxDataGrid<any, any>) {
    if (!datagrid) return;

    datagrid.columnOption('id', 'visible', false);

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(this.worksheetName());
    await exportDataGrid({ component: datagrid, worksheet: worksheet });
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${this.fileName()}.xlsx`);
  }
}
